import { render, staticRenderFns } from "./SuccessCheck.vue?vue&type=template&id=70a53fd5"
import script from "./SuccessCheck.vue?vue&type=script&lang=js"
export * from "./SuccessCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports